import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [{
  path: '/login',
  component: () => import('@/views/login/index'),
  hidden: true
},
{
  path: '/404',
  component: () => import('@/views/404'),
  hidden: true
},
{
  path: '',
  component: Layout,
  redirect: '/home',
  children: [{
    path: 'home',
    name: 'home',
    component: () => import('@/views/home/index'),
    meta: {
      title: '首页',
      icon: 'home'
    }
  }]
}
]

export const asyncRouterMap = [
  // 权限管理
  {
    path: '/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {
      title: '权限',
      icon: 'ums'
    },
    children: [{
      path: 'admin',
      name: 'admin',
      component: () => import('@/views/ums/admin/index'),
      meta: {
        title: '用户列表',
        icon: 'ums-admin'
      }
    },
    {
      path: 'role',
      name: 'role',
      component: () => import('@/views/ums/role/index'),
      meta: {
        title: '角色列表',
        icon: 'ums-role'
      }
    },
    {
      path: 'allocMenu',
      name: 'allocMenu',
      component: () => import('@/views/ums/role/allocMenu'),
      meta: {
        title: '分配菜单'
      },
      hidden: true
    },
    {
      path: 'allocResource',
      name: 'allocResource',
      component: () => import('@/views/ums/role/allocResource'),
      meta: {
        title: '分配资源'
      },
      hidden: true
    },
    {
      path: 'menu',
      name: 'menu',
      component: () => import('@/views/ums/menu/index'),
      meta: {
        title: '菜单列表',
        icon: 'ums-menu'
      }
    },
    {
      path: 'addMenu',
      name: 'addMenu',
      component: () => import('@/views/ums/menu/add'),
      meta: {
        title: '添加菜单'
      },
      hidden: true
    },
    {
      path: 'updateMenu',
      name: 'updateMenu',
      component: () => import('@/views/ums/menu/update'),
      meta: {
        title: '修改菜单'
      },
      hidden: true
    },
    {
      path: 'resourceCategory',
      name: 'resourceCategory',
      component: () => import('@/views/ums/resource/categoryList'),
      meta: {
        title: '资源分类'
      },
      hidden: true
    }
    ]
  },
  // 数据采集系统
  {
    path: '/collection',
    component: Layout,
    name: 'collection',
    meta: {
      title: '数据采集系统',
      icon: 'collection'
    },
    children: [
      {
        path: 'flowMonitoring/list',
        name: 'flowMonitoringList',
        component: () => import('@/views/collection/flowMonitoring/list/index'),
        meta: {
          title: '流量监测',
          icon: 'flow'
        }
      },
      {
        path: 'flowMonitoring/details',
        name: 'flowMonitoringDetails',
        component: () => import('@/views/collection/flowMonitoring/details/index'),
        meta: {
          title: '流量监测详情',
          icon: 'flowDetails'
        },
        hidden: true
      }, {
        path: 'waterLevel/list',
        name: 'waterLevelList',
        component: () => import('@/views/collection/waterLevel/list/index'),
        meta: {
          title: '水位监测',
          icon: 'flow'
        }
      },
      {
        path: 'waterLevel/details',
        name: 'waterLevelDetails',
        component: () => import('@/views/collection/waterLevel/details/index'),
        meta: {
          title: '水位监测详情',
          icon: 'monitoring'
        },
        hidden: true
      }, {
        path: 'tension/list',
        name: 'tensionList',
        component: () => import('@/views/collection/tension/list/index'),
        meta: {
          title: '压力监测',
          icon: 'monitoring'
        },
      },
      {
        path: 'tension/details',
        name: 'tensionDetails',
        component: () => import('@/views/collection/tension/details/index'),
        meta: {
          title: '压力监测详情',
          icon: 'monitoring'
        },
        hidden: true
      }]
  },
  // 信息管理系统
  {
    path: '/information',
    component: Layout,
    // redirect: '/assets/river',
    name: 'information',
    meta: {
      title: '信息管理系统',
      icon: 'information'
    },
    children: [
      {
        path: 'assets/list',
        name: 'assetsList',
        component: () => import('@/views/information/assets/list/index'),
        meta: {
          title: '设备信息管理',
          icon: 'assets'
        }
      },
      {
        path: 'assets/create',
        name: 'assetsCreate',
        component: () => import('@/views/information/assets/create/index'),
        meta: {
          title: '添加设备',
          icon: 'assets'
        },
        hidden: true
      },
      {
        path: 'assets/details',
        name: 'assetsDetails',
        component: () => import('@/views/information/assets/details/index'),
        meta: {
          title: '设备详情',
          icon: 'assets'
        },
        hidden: true
      },
      {
        path: 'irrigate/list',
        name: 'irrigateList',
        component: () => import('@/views/information/irrigate/list/index'),
        meta: {
          title: '灌区管理',
          icon: 'irrigate'
        }
      },
      {
        path: 'irrigate/create',
        name: 'irrigateCreate',
        component: () => import('@/views/information/irrigate/create/index'),
        meta: {
          title: '添加灌区',
          icon: 'create'
        },
        hidden: true
      },
      {
        path: 'monitor/list',
        name: 'monitorList',
        component: () => import('@/views/information/irrigateMonitor/list/index'),
        meta: {
          title: '灌区监控',
          icon: 'monitoring'
        }
      },
      {
        path: 'monitor/details',
        name: 'monitorDetails',
        component: () => import('@/views/information/irrigateMonitor/details/index'),
        meta: {
          title: '监测详情',
          icon: 'monitoring'
        },
        hidden: true
      },
      {
        path: 'gate/list',
        name: 'gateList',
        component: () => import('@/views/information/gate/list/index'),
        meta: {
          title: '闸门管理',
          icon: 'gate'
        }
      },
      {
        path: 'gate/details',
        name: 'gateDetails',
        component: () => import('@/views/information/gate/details/index'),
        meta: {
          title: '闸门详情',
          icon: 'gate'
        },
        hidden: true
      },
      {
        path: 'gate/edit',
        name: 'gateeEdit',
        component: () => import('@/views/information/gate/edit/index'),
        meta: {
          title: '编辑闸门',
          icon: 'gate'
        },
        hidden: true
      },
      {
        path: 'ditch/list',
        name: 'ditchList',
        component: () => import('@/views/information/ditch/list/index'),
        meta: {
          title: '渠道信息管理',
          icon: 'project'
        }
      },
      {
        path: 'ditch/create',
        name: 'ditchCreate',
        component: () => import('@/views/information/ditch/create/index'),
        meta: {
          title: '添加渠道',
          icon: 'create'
        },
        hidden: true
      },
      {
        path: 'ditch/details',
        name: 'ditchDetails',
        component: () => import('@/views/information/ditch/details/index'),
        meta: {
          title: '渠道详情',
          icon: 'project'
        },
        hidden: true
      }]
  },
  // 巡检预警系统
  {
    path: '/patrol',
    component: Layout,
    // redirect: '/patrol/river',
    name: 'patrol',
    meta: {
      title: '巡检预警系统',
      icon: 'patrol'
    },
    children: [{
      path: 'workorder/list',
      name: 'workorderList',
      component: () => import('@/views/patrol/workorder/list/index'),
      meta: {
        title: '工单管理',
        icon: 'workorder'
      }
    },
    {
      path: 'workorder/approval',
      name: 'workorderApproval',
      component: () => import('@/views/patrol/workorder/approval/index'),
      meta: {
        title: '工单审批',
        icon: 'approval'
      }
    },
    {
      path: 'workorder/create',
      name: 'workorderCreate',
      component: () => import('@/views/patrol/workorder/create/index'),
      meta: {
        title: '添加工单',
        icon: 'create'
      },
      hidden: true
    },
    {
      path: 'workorder/details',
      name: 'workorderDetails',
      component: () => import('@/views/patrol/workorder/details/index'),
      meta: {
        title: '工单详情',
        icon: 'workorder'
      },
      hidden: true
    },
    {
      path: 'workorder/approvalDetails',
      name: 'workorderApprovalDetails',
      component: () => import('@/views/patrol/workorder/approval/details'),
      meta: {
        title: '工单详情',
        icon: 'workorder'
      },
      hidden: true
    },
    {
      path: 'warning/list',
      name: 'warningList',
      component: () => import('@/views/patrol/warning/list/index'),
      meta: {
        title: '系统预警',
        icon: 'warning'
      }
    },
    {
      path: 'warning/details',
      name: 'warningDetails',
      component: () => import('@/views/patrol/warning/details/index'),
      meta: {
        title: '预警详情',
        icon: 'warning'
      },
      hidden: true
    }
    ]
  },
  // 水利一张图
  {
    path: '/waterConservancyMap',
    component: () => import('@/views/waterConservancyMap/index'),
    redirect: '/waterConservancyMap/index',
    children: [{
      path: 'index',
      name: 'waterConservancyMap',
      component: () => import('@/views/waterConservancyMap/index'),
      meta: {
        title: '一张图',
        icon: 'waterPic'
      }
    }]
  },
  // 收件箱
  {
    path: '',
    component: Layout,
    // redirect: '/inbox/index',
    name: 'inbox',
    meta: {
      title: '收件箱',
      icon: 'draft'
    },
    children: [{
      path: 'inbox',
      name: 'inbox',
      component: () => import('@/views/inbox/list/index'),
      meta: {
        title: '收件箱',
        icon: 'draft'
      }
    }]
  },
  // 文件存储系统
  {
    path: '/file',
    component: Layout,
    // redirect: '/patrol/river',
    name: 'file',
    meta: {
      title: '文件存储系统',
      icon: 'folder'
    },
    children: [
      {
        path: 'irrigation/list',
        name: 'irrigationList',
        component: () => import('@/views/file/irrigation/list/index'),
        meta: {
          title: '灌区管理文件',
          icon: 'file'
        }
      },
      {
        path: 'irrigation/create',
        name: 'irrigationCreate',
        component: () => import('@/views/file/irrigation/create/index'),
        meta: {
          title: '灌区管理上传文件',
          icon: 'file'
        },
        hidden: true
      },
      {
        path: 'irrigation/details',
        name: 'irrigationDetails',
        component: () => import('@/views/file/irrigation/details/index'),
        meta: {
          title: '灌区管理文件详情',
          icon: 'file'
        },
        hidden: true
      },
      {
        path: 'waterRight/list',
        name: 'waterRightList',
        component: () => import('@/views/file/waterRight/list/index'),
        meta: {
          title: '水权分配文件',
          icon: 'file'
        }
      },
      {
        path: 'waterRight/create',
        name: 'waterRightCreate',
        component: () => import('@/views/file/waterRight/create/index'),
        meta: {
          title: '水权分配上传文件',
          icon: 'file'
        },
        hidden: true
      },
      {
        path: 'waterRight/details',
        name: 'waterRightdetails',
        component: () => import('@/views/file/waterRight/details/index'),
        meta: {
          title: '水权分配文件详情',
          icon: 'file'
        },
        hidden: true
      },
      {
        path: 'transaction/list',
        name: 'transactionList',
        component: () => import('@/views/file/transaction/list/index'),
        meta: {
          title: '水权交易文件',
          icon: 'file'
        }
      },
      {
        path: 'transaction/create',
        name: 'transactionCreate',
        component: () => import('@/views/file/transaction/create/index'),
        meta: {
          title: '水权交易上传文件',
          icon: 'file'
        },
        hidden: true
      },
      {
        path: 'transaction/details',
        name: 'transactiondetails',
        component: () => import('@/views/file/transaction/details/index'),
        meta: {
          title: '水权交易文件详情',
          icon: 'file'
        },
        hidden: true
      },
      {
        path: 'customized/list',
        name: 'customizedList',
        component: () => import('@/views/file/customized/list/index'),
        meta: {
          title: '水价定制文件',
          icon: 'file'
        }
      },
      {
        path: 'customized/create',
        name: 'customizedCreate',
        component: () => import('@/views/file/customized/create/index'),
        meta: {
          title: '水价定制上传文件',
          icon: 'file'
        },
        hidden: true
      },
      {
        path: 'customized/details',
        name: 'customizeddetails',
        component: () => import('@/views/file/customized/details/index'),
        meta: {
          title: '水价定制文件详情',
          icon: 'file'
        },
        hidden: true
      },
      {
        path: 'policy/list',
        name: 'policyList',
        component: () => import('@/views/file/policy/list/index'),
        meta: {
          title: '政策文件',
          icon: 'file'
        }
      },
      {
        path: 'policy/create',
        name: 'policyCreate',
        component: () => import('@/views/file/policy/create/index'),
        meta: {
          title: '政策上传文件',
          icon: 'file'
        },
        hidden: true
      },
      {
        path: 'policy/details',
        name: 'policydetails',
        component: () => import('@/views/file/policy/details/index'),
        meta: {
          title: '政策文件详情',
          icon: 'file'
        },
        hidden: true
      },
      {
        path: 'plan/list',
        name: 'planList',
        component: () => import('@/views/file/plan/list/index'),
        meta: {
          title: '紧急预案',
          icon: 'file'
        }
      },
      {
        path: 'plan/create',
        name: 'planCreate',
        component: () => import('@/views/file/plan/create/index'),
        meta: {
          title: '紧急预案上传文件',
          icon: 'file'
        },
        hidden: true
      },
      {
        path: 'plan/details',
        name: 'plandetails',
        component: () => import('@/views/file/plan/details/index'),
        meta: {
          title: '紧急预案文件详情',
          icon: 'file'
        },
        hidden: true
      },

      {
        path: 'fileTemplate/list',
        name: 'fileTemplateList',
        component: () => import('@/views/file/fileTemplate/list/index'),
        meta: {
          title: '文件模板',
          icon: 'file'
        }
      },
      {
        path: 'fileTemplate/create',
        name: 'fileTemplateCreate',
        component: () => import('@/views/file/fileTemplate/create/index'),
        meta: {
          title: '文件模板上传文件',
          icon: 'file'
        },
        hidden: true
      },
      {
        path: 'fileTemplate/details',
        name: 'fileTemplatedetails',
        component: () => import('@/views/file/fileTemplate/details/index'),
        meta: {
          title: '文件模板文件详情',
          icon: 'file'
        },
        hidden: true
      },
    ]
  },
  // 水权监管系统
  {
    path: '/waterRightSupervision',
    component: Layout,
    name: 'waterRightSupervision',
    meta: {
      title: '水权监管系统',
      icon: 'waterRightSupervision'
    },
    children: [
      {
        path: 'management/list',
        name: 'managementList',
        component: () => import('@/views/waterRightSupervision/management/list/index'),
        meta: {
          title: '用户管理',
          icon: 'management'
        }
      },
      {
        path: 'management/create',
        name: 'managementCreate',
        component: () => import('@/views/waterRightSupervision/management/create/index'),
        meta: {
          title: '用户管理添加',
          icon: 'management'
        },
        hidden: true
      }, {
        path: 'information/list',
        name: 'informationList',
        component: () => import('@/views/waterRightSupervision/information/list/index'),
        meta: {
          title: '水权信息',
          icon: 'information'
        }
      }, {
        path: 'information/create',
        name: 'informationCreate',
        component: () => import('@/views/waterRightSupervision/information/create/index'),
        meta: {
          title: '水权信息添加',
          icon: 'information'
        },
        hidden: true
      },
      {
        path: 'information/details',
        name: 'informationDetails',
        component: () => import('@/views/waterRightSupervision/information/details/index'),
        meta: {
          title: '水权信息用水详情',
          icon: 'information'
        },
        hidden: true
      }, {
        path: 'information/createCompany',
        name: 'informationCreateCompany',
        component: () => import('@/views/waterRightSupervision/information/createCompany/index'),
        meta: {
          title: '水权信息添加用水单位',
          icon: 'information'
        },
        hidden: true
      }, {
        path: 'transfer/list',
        name: 'transferList',
        component: () => import('@/views/waterRightSupervision/transfer/list/index'),
        meta: {
          title: '水权转让',
          icon: 'transfer'
        }
      }, {
        path: 'transfer/create',
        name: 'transferCreate',
        component: () => import('@/views/waterRightSupervision/transfer/create/index'),
        meta: {
          title: '水权交易',
          icon: 'transfer'
        },
        hidden: true
      },
      {
        path: 'transaction/list',
        name: 'transactionList',
        component: () => import('@/views/waterRightSupervision/transaction/list/index'),
        meta: {
          title: '交易记录',
          icon: 'workorder'
        }
      },
      {
        path: 'approval/list',
        name: 'approvalList',
        component: () => import('@/views/waterRightSupervision/approval/list/index'),
        meta: {
          title: '交易审批',
          icon: 'approval'
        }
      }, {
        path: 'approval/details',
        name: 'approvalDetails',
        component: () => import('@/views/waterRightSupervision/approval/details/index'),
        meta: {
          title: '交易审批详情',
          icon: 'approval'
        },
        hidden: true
      },
    ]
  },
  // 水价计费系统
  {
    path: '/WaterPriceCharging',
    component: Layout,
    name: 'WaterPriceCharging',
    meta: {
      title: '水价计费系统',
      icon: 'WaterPriceCharging'
    },
    children: [
      {
        path: 'WaterPricing/list',
        name: 'WaterPricingList',
        component: () => import('@/views/WaterPriceCharging/WaterPricing/list/index'),
        meta: {
          title: '水费计价',
          icon: 'WaterPricing'
        }
      }, {
        path: 'publicity/list',
        name: 'publicityList',
        component: () => import('@/views/WaterPriceCharging/publicity/list/index'),
        meta: {
          title: '水费公示',
          icon: 'publicity'
        }
      }, {
        path: 'publicity/create',
        name: 'publicityCreate',
        component: () => import('@/views/WaterPriceCharging/publicity/create/index'),
        meta: {
          title: '水费公示发布',
          icon: 'publicity'
        },
        hidden: true
      }, {
        path: 'pay/list',
        name: 'payList',
        component: () => import('@/views/WaterPriceCharging/pay/list/index'),
        meta: {
          title: '缴费记录',
          icon: 'workorder'
        }
      }, {
        path: 'pay/create',
        name: 'payCreate',
        component: () => import('@/views/WaterPriceCharging/pay/create/index'),
        meta: {
          title: '缴费记录添加',
          icon: 'workorder'
        },
        hidden: true
      },{
        path: 'approval/list',
        name: 'approvalList',
        component: () => import('@/views/WaterPriceCharging/approval/list/index'),
        meta: {
          title: '水价审批',
          icon: 'approval'
        }
      }, {
        path: 'approval/details',
        name: 'approvalDetails',
        component: () => import('@/views/WaterPriceCharging/approval/details/index'),
        meta: {
          title: '水价审批详情',
          icon: 'approval'
        },
        hidden: true
      },
    ]
  },
  // 404
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js